import { render, staticRenderFns } from "./ManagerComponent.vue?vue&type=template&id=7320a88a&scoped=true"
import script from "./ManagerComponent.vue?vue&type=script&lang=js"
export * from "./ManagerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7320a88a",
  null
  
)

export default component.exports